module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/play-circle-894c02884e16261cf359eb3819de92b9.svg";